import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { PortalPageHeader } from "@/components/portal-page-header";
import { useTeacherClassesGetTeacherClassDetail } from "@/orval/teacher-classes";
import { useTeacherClassUpdatesGetUpdate } from "@/orval/teacher-class-updates";
import { TeacherClassUpdateEditor } from "./-components/teacher-class-update-editor";

const paramsSchema = z.object({
  updateId: z.coerce.number().int().positive(),
});

export const Route = createFileRoute("/_app/organizations/$organizationId/teacher/classes_/$classId/updates/$updateId")(
  {
    params: {
      parse: (params) => paramsSchema.parse(params),
    },
    component: RouteComponent,
  },
);

function RouteComponent() {
  const { organizationId, classId, updateId } = Route.useParams();
  const { data: classDetail } = useTeacherClassesGetTeacherClassDetail(organizationId, classId);
  const { data: update } = useTeacherClassUpdatesGetUpdate(organizationId, classId, updateId);
  const updateTitle = update?.title ?? "Update";

  return (
    <>
      <PortalPageHeader
        className="mb-6"
        breadcrumbs={[
          { label: "Classes", to: "/organizations/$organizationId/teacher/classes", params: { organizationId } },
          {
            label: classDetail?.name ?? "Class",
            to: "/organizations/$organizationId/teacher/classes/$classId",
            params: { organizationId, classId },
          },
          {
            label: "Updates",
            to: "/organizations/$organizationId/teacher/classes/$classId/updates",
            params: { organizationId, classId },
          },
          { label: updateTitle },
        ]}
        title={updateTitle}
        subtitle="Edit the update, manage attachments, and control publication."
      />

      <div className="mx-auto w-full max-w-3xl">
        <TeacherClassUpdateEditor organizationId={organizationId} classId={classId} updateId={updateId} />
      </div>
    </>
  );
}
